export const BASE_API_URL =
  window.location.hostname == "localhost"
    ? "http://localhost:7111"
    : "https://api.carelysandahmad.com";
